const EMPLOYER = 'employer'

export enum EmployerRoutePathsEnum {
  DASHBOARD = `/${EMPLOYER}/dashboard`,
}
